
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
import {TransitionLink} from "../components/TransitionLink";
export const title = "Keeping AI slop out of this blog";
export const description = "My stance on using AI on bomberfish.ca.";
export const tags = ["Meta", "AI"];
export const image = "/blog-images/img2181.jpg";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    em: "em",
    img: "img",
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/img2181.jpg",
        alt: ""
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      }), _jsx("br", {}), _jsx("subt", {
        children: "Taken on an iPhone 13 Pro Max. No further editing, apart from cropping."
      })]
    }), "\n", _jsx(_components.p, {
      children: "Okay, that was kind of a lie. But let me explain."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "I don't have anything against AI tools."
      }), " On this blog, I occasionally use tools such as Apple's proofread feature, and other tools such as Kagi Doc (which is in a private preview as of the writing of this post), to help polish an already-written post. I've also used AI to help create some of the features and elements on bomberfish.ca. Most recently, I used AI to create the animated interactive background (based on a set of guidelines that I set out), and the Google Photo Sphere viewer component used in the ", _jsx(TransitionLink, {
        href: "/blog/google-glass-retrospective",
        class: "router-link",
        children: "Google Glass post"
      }), " (although, that actually wraps ", _jsx(_components.a, {
        href: "https://photo-sphere-viewer.js.org/",
        children: "an existing library"
      }), "). It's also really useful for menial tasks such as ", _jsx(_components.a, {
        href: "https://github.com/bomberfish/bomberfish.ca/commit/2cdeb7bf22040e5c54f41c7c2f604f1433040869",
        children: "cleaning up stylesheets"
      }), " and ", _jsx(_components.a, {
        href: "https://github.com/bomberfish/bomberfish.ca/commit/84520f9b69aca1e624e395498fe85df487dc30a0",
        children: "migrating library versions"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "But, I would like to make some commitments here."
    }), "\n", _jsxs(_components.p, {
      children: ["I will ", _jsx(_components.em, {
        children: "never"
      }), " fully AI-generate any text or image on my blog. If I refine a post using AI tools, I will commit both the unedited and edited versions to the git repository. You can see an example of such a diff ", _jsx(_components.a, {
        href: "https://github.com/bomberfish/bomberfish.ca/commit/31f52ec4b4ac9f5940b48da0bc9fae6bba8f0d1d",
        children: "here"
      }), ". If an image is enhanced with AI-powered tools (such as Topaz Photo for upscaling), I will disclose it as such in the image caption."]
    }), "\n", _jsx(_components.p, {
      children: "I'm not going to outsource my creativity to a robot. This blog is a place for me to express myself, and I intend on keeping it that way. It has been, and will remain, a slop-free zone."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	